/**
 * Alatreyu — Leave a Review Modal
 *
 * Three-step flow:
 *   1. Email + name form → POST /api/reviews/lookup → get products
 *   2. Product selection → POST /api/reviews/send → trigger Judge.me emails
 *   3. Thank you confirmation
 *
 * Uses the storefront API as a secure proxy to Odoo + Judge.me.
 */
(function () {
  'use strict';

  function isSafeUrl(url) {
    if (!url) return false;
    return /^https?:\/\//i.test(url) || /^\//.test(url);
  }

  var API_BASE = 'https://front.4147r3yu.com/api/reviews';

  var modal = document.getElementById('LeaveReviewModal');
  if (!modal) return;

  var stepForm = document.getElementById('leave-review-step-form');
  var stepProducts = document.getElementById('leave-review-step-products');
  var stepThanks = document.getElementById('leave-review-step-thanks');
  var form = document.getElementById('leave-review-form');
  var emailInput = document.getElementById('leave-review-email');
  var nameInput = document.getElementById('leave-review-name');
  var errorEl = document.getElementById('leave-review-error');
  var submitBtn = document.getElementById('leave-review-submit');
  var productsContainer = document.getElementById('leave-review-products');
  var sendBtn = document.getElementById('leave-review-send');
  var sendErrorEl = document.getElementById('leave-review-send-error');

  // State
  var foundProducts = [];
  var customerEmail = '';
  var customerName = '';

  // --- Helpers ---

  function showStep(step) {
    stepForm.hidden = step !== 'form';
    stepProducts.hidden = step !== 'products';
    stepThanks.hidden = step !== 'thanks';
  }

  function showError(el, msg) {
    el.textContent = msg;
    el.hidden = false;
  }

  function hideError(el) {
    el.textContent = '';
    el.hidden = true;
  }

  function setLoading(btn, loading) {
    btn.disabled = loading;
    if (loading) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = 'Loading\u2026';
      btn.classList.add('alatreyu-leave-review__btn--loading');
    } else {
      btn.textContent = btn.dataset.originalText || btn.textContent;
      btn.classList.remove('alatreyu-leave-review__btn--loading');
    }
  }

  function esc(s) {
    var d = document.createElement('span');
    d.textContent = s || '';
    return d.innerHTML;
  }

  // --- Open / Close ---

  function openModal() {
    showStep('form');
    hideError(errorEl);
    hideError(sendErrorEl);
    emailInput.value = '';
    nameInput.value = '';
    productsContainer.innerHTML = '';
    foundProducts = [];

    // Pre-fill email for logged-in customers
    if (window.alatreyuCustomerEmail) {
      emailInput.value = window.alatreyuCustomerEmail;
    }

    modal.showModal();
  }

  function closeModal() {
    modal.close();
  }

  // Open triggers: any element with [data-leave-review-open]
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-leave-review-open]');
    if (trigger) {
      e.preventDefault();
      openModal();
    }
  });

  // Close triggers
  modal.querySelectorAll('[data-leave-review-close]').forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  // Close on backdrop click
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  // --- Step 1: Lookup ---

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    hideError(errorEl);

    customerEmail = emailInput.value.trim();
    customerName = nameInput.value.trim();

    if (!customerEmail || !customerName) {
      showError(errorEl, 'Please enter both your email and first name.');
      return;
    }

    setLoading(submitBtn, true);

    fetch(API_BASE + '/lookup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: customerEmail, name: customerName }),
    })
      .then(function (res) {
        if (res.status === 429) {
          throw new Error('Too many requests. Please wait a moment and try again.');
        }
        return res.json();
      })
      .then(function (data) {
        setLoading(submitBtn, false);

        if (!data.products || data.products.length === 0) {
          showError(
            errorEl,
            data.hint || 'We couldn\u2019t find any orders with that email and name. Please check your details and try again.'
          );
          return;
        }

        foundProducts = data.products;
        renderProducts();
        showStep('products');
      })
      .catch(function (err) {
        setLoading(submitBtn, false);
        showError(errorEl, err.message || 'Something went wrong. Please try again.');
      });
  });

  // --- Render product cards ---

  function renderProducts() {
    productsContainer.innerHTML = '';

    foundProducts.forEach(function (product, i) {
      var card = document.createElement('label');
      card.className = 'alatreyu-leave-review__product';

      var safeImgUrl = isSafeUrl(product.image_url) ? esc(product.image_url) : '';
      card.innerHTML =
        '<input type="checkbox" checked class="alatreyu-leave-review__checkbox" value="' +
        product.id +
        '" name="product_ids">' +
        (safeImgUrl ? '<img src="' + safeImgUrl +
        '" alt="' + esc(product.name) +
        '" class="alatreyu-leave-review__product-img" width="64" height="64" loading="lazy">' : '') +
        '<div class="alatreyu-leave-review__product-info">' +
        '<span class="alatreyu-leave-review__product-name">' +
        esc(product.name) +
        '</span>' +
        (product.ordered_on ? '<span class="alatreyu-leave-review__product-date">Ordered on ' + esc(product.ordered_on) + '</span>' : '') +
        '</div>';

      productsContainer.appendChild(card);
    });
  }

  // --- Step 2: Send review requests ---

  sendBtn.addEventListener('click', function () {
    hideError(sendErrorEl);

    var checked = productsContainer.querySelectorAll(
      'input[name="product_ids"]:checked'
    );
    var selectedIds = [];
    checked.forEach(function (cb) {
      selectedIds.push(parseInt(cb.value, 10));
    });

    if (selectedIds.length === 0) {
      showError(sendErrorEl, 'Please select at least one product.');
      return;
    }

    setLoading(sendBtn, true);

    fetch(API_BASE + '/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: customerEmail,
        name: customerName,
        product_ids: selectedIds,
      }),
    })
      .then(function (res) {
        if (res.status === 429) {
          throw new Error('Too many requests. Please wait a moment and try again.');
        }
        return res.json();
      })
      .then(function (data) {
        setLoading(sendBtn, false);

        if (data.success) {
          showStep('thanks');
        } else {
          showError(
            sendErrorEl,
            data.error || data.message || 'Something went wrong. Please try again.'
          );
        }
      })
      .catch(function (err) {
        setLoading(sendBtn, false);
        showError(sendErrorEl, err.message || 'Something went wrong. Please try again.');
      });
  });
})();
